<app-home-behaviorlive *ngIf="settings.brand.brandName == 'BehaviorLive'"></app-home-behaviorlive>
<app-home-gathergo *ngIf="settings.brand.brandName == 'GatherGo'"></app-home-gathergo>
